import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { HBox, VBox } from '../../../../components/Box';
import { Checkbox } from '../../../../components/Checkbox';
import { selectInvoice } from '../../../Invoices/selectors';
import { getPropByName } from '../../../../utils/props';
import { selectAddressTypes } from '../../../Address/selectors';
import { LANG } from './translations';
import { SaleAgreementHeader } from './SaleAgreementHeader';
import { SaleAgreementLabel } from './SaleAgreementLabel';
import { SaleAgreementFooter } from './SaleAgreementFooter';
import { VEHICLE_PURPOSE, VEHICLE_TAX_TYPE } from '../../constants';
import { fixPriceFormat } from '../../../../utils/string';
import { REQUEST_INVOICE_TRADE_IN_VEHICLES } from '../../../Invoices/constants';
import { getInvoiceTradeInVehicles } from '../../../Invoices/actions';
import { selectWork } from '../../../Api/selectors';
import { Loader } from '../../../../components/Loader';
import { formatterDistance } from '../../helpers';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';




const Container = styled.div`
  height: 100%;
  font-family: 'Open sans', sans-serif;
  line-height: 1.4;
  font-size: 14px;
  padding: 25px 30px 0px 30px;

  .section {
    margin-bottom: 3px;
  }

  .section-title {
    margin-bottom: 2px;
  }
  .subtitle {
    font-size: 14px;
  }

  width: 100%;
  max-width: 1240px;
  background-color: white;
  color: black;
`;

const Body = styled.div`
  padding: 0px 45px;
  position: relative;
`;

const DocField = styled(HBox)`
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '3px')};
  height: ${props => (props.height ? props.height : '24px')};

  .label {
    height: 100%;
    padding-left: 6px;
    width: ${props => (props.labelOnly ? '100%' : props.large ? '220px' : props.wideLabel ? '70%' : '50%')};
    background-color: ${props => (props.lightgrey ? '#b8b9be' : '#c2c8e2')};
    font-weight: ${props => !props.strongValue && '600'};
  }
  .value {
    width: ${props => (props.withoutLabelField ? '100%' : props.mediumValueWide ? '60%' : props.large ? '80%' : '50%')};
    padding-left: 6px;
    font-weight: ${props => props.strongValue && '600'};
    height: ${props => (props.height ? props.height : '100%')};
    background-color: #f4f7fe;
  }
`;

const InitialsField = styled(HBox)`
  margin-bottom: 2px;
  padding: 6px;
  background-color: #f4f7fe;
  .initial-field-description {
    width: 60%;
    font-size: 12px;
  }
  .initials-input {
    width: 40%;
    height: 50px;
    margin: 15px;
    font-size: 12px;
    text-align: center;
    background-color: #fff;
  }
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: black;
`;

const STATE = {
  tradeIn: [],
};

/* eslint-disable react/prefer-stateless-function */
class CompanySaleAgreementComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.fetchTradeInVehicles(result => {
      if (result?.[0]?.id) {
        this.setState({ tradeIn: result });
      }
    });
  }

  get outgoingCompany() {
    return this.props.invoice?.outgoingCompany;
  }

  get homeAddress() {
    const homeId = this.props.addressTypes.filter(t => t.name === 'home')[0].id;
    const homeAddress = this.outgoingCompany?.addresses.find(address => address?.type?.id == homeId);

    return homeAddress;
  }

  get language() {
    return LANG[this.props.language] ?? {};
  }

  get products() {
    const products = this.props.invoice?.invoiceSubjects?.filter(sub => sub.type == 'product');
    return products;
  }

  get priceToDeliver() {
    let price =
      getPropByName(this.props.vehicle, 'tax_type') == VEHICLE_TAX_TYPE.BTW
        ? 'financial_purchase_price_incl_vat_bpm'
        : 'financial_purchase_price_marge_bpm';

    return getPropByName(this.props.vehicle, price) ?? 0;
  }

  get tradeInTotalPrice() {
    const price = this.state.tradeIn
      ?.map(v => getPropByName(v, 'financial_purchase_price_incl_vat_bpm'))
      ?.reduce((price, currentVAlue) => +price + +currentVAlue, 0);

    return price ?? 0;
  }

  get subTotalAmount() {
    return this.props.invoice?.financialTotalAmount;
  }

  get totalAmounts() {
    const total = +this.subTotalAmount - +this.tradeInTotalPrice;
    return total ?? 0;
  }

  renderTradeInFields(vehicle) {
    return (
      <HBox>
        <VBox style={{ width: '49.5%' }}>
          {['brand_name', 'model_name', 'last_4_digits_vin', 'date_first_allowance', 'date_apk_expiry', ''].map(type => {
            if (type !== 'last_4_digits_vin') {
              return (
                <DocField key={type} large mediumValueWide strongValue>
                  <div className="label">{this.language[type]}</div>
                  <div className="value">{getPropByName(vehicle, type)}</div>
                </DocField>
              );
            }

            return (
              <DocField key={type} large mediumValueWide strongValue>
                <div className="label">{this.language[type]}</div>
                <div className="value">{getPropByName(vehicle, 'vin') && getPropByName(vehicle, 'vin')?.slice(-4)}</div>
              </DocField>
            );
          })}
          {['nap'].map(type => (
            <DocField key={type} large mediumValueWide strongValue>
              <div className="label">{this.language[type]}</div>
              <div className="value">
                <HBox left style={{ fontSize: '14px' }}>
                  <Checkbox>{this.language['logical']}</Checkbox>
                  <Checkbox>{this.language['illogical']}</Checkbox>
                </HBox>
              </div>
            </DocField>
          ))}
          {['technical_state'].map(type => (
            <DocField key={type} large mediumValueWide strongValue>
              <div className="label">{this.language[type]}</div>
              <div className="value">
                <HBox left style={{ fontSize: '14px' }}>
                  <Checkbox>{this.language['good']}</Checkbox>
                </HBox>
              </div>
            </DocField>
          ))}
        </VBox>

        <VBox style={{ width: '49.5%' }}>
          {['model_info', 'fuel_type', 'regplate', 'base_color', 'mileage'].map(type => {
            let value = getPropByName(vehicle, type);
            if (type == 'mileage') {
              value = getPropByName(vehicle, type)
                ? formatterDistance.format(getPropByName(vehicle, type))?.replace(',', '.')
                : '';
            }
            return (
              <DocField key={type} large mediumValueWide strongValue>
                <div className="label">{this.language[type]}</div>
                <div className="value">{value}</div>
              </DocField>
            );
          })}
          <DocField large withoutLabelField strongValue>
            <div className="value">
              <HBox spaceAround style={{ fontSize: '14px' }}>
                <Checkbox checked={getPropByName(vehicle, 'vehicle_purpose') == VEHICLE_PURPOSE.Passenger}>
                  {this.language['passenger']}
                </Checkbox>
                <Checkbox checked={getPropByName(vehicle, 'vehicle_purpose') == VEHICLE_PURPOSE.Commercial}>
                  {this.language['commercial']}
                </Checkbox>
              </HBox>
            </div>
          </DocField>
          <DocField large mediumValueWide strongValue>
            <div className="label">{this.language['injury']}</div>
            <div className="value">
              <HBox spaceAround style={{ fontSize: '14px' }}>
                <Checkbox>{this.language['yes_taxatierapport']}</Checkbox>
                <Checkbox>{this.language['no']}</Checkbox>
              </HBox>
            </div>
          </DocField>
          <DocField large strongValue>
            <div className="value">{this.language['financial_purchase_price_incl_vat_bpm']}</div>
            <div className="label">
              {getPropByName(vehicle, 'financial_purchase_price_incl_vat_bpm') &&
                `€ ${fixPriceFormat(getPropByName(vehicle, 'financial_purchase_price_incl_vat_bpm'))}`}
            </div>
          </DocField>
        </VBox>
      </HBox>
    );
  }

  render() {
    const vehicle = this.props.vehicle;
    const company = this.props.company;
    const address = this.props.address;

    if (this.props.tradeInWork) return <Loader small />;

    return (

     
      
      <Container>
        <SaleAgreementHeader />
        <Body>
          <HBox id="agreement-main" className="section">
            <VBox>
              <SaleAgreementLabel label={this.language?.purchase_agreement} />
              <h2 className="subtitle">{this.language?.['purchase_agreement_subtitle']}</h2>
            </VBox>
            <VBox style={{ width: '55%' }}>
              <DocField>
                <div className="label">{this.language?.['delivery_date']}</div>
                <div className="value"></div>
              </DocField>
              <DocField>
                <div className="label">{this.language?.['period']}</div>
                <div className="value"></div>
              </DocField>
            </VBox>
          </HBox>
          <VBox id="consumer-data">
            <HBox>
              <HBox className="section-title">
                <strong>{this.language?.['consumer_data']}</strong>
              </HBox>
              <DocField style={{ width: '55%' }}>
                <div className="value">
                  <strong>{this.language?.['relation_number']}</strong>
                </div>
                <div className="value">{(address?.relation_number || company?.['relation_number']) ?? ''}</div>
              </DocField>
            </HBox>
            {['name', 'addressLine1', 'postcodeAndPlace', 'phone_number', 'company_email'].map(type => {
              let model = company;
              if (type == 'addressLine1' || type == 'postcodeAndPlace') {
                model = address;
              }

              if (type == 'name') {
                let label =
                  this.props.agreementType == 'company'
                    ? `${getPropByName(company, 'name') ?? ''}`
                    : `${getPropByName(company, 'name') ?? ''} ${getPropByName(company, 'surname') ?? ''}`;
                return (
                  <DocField key={type} large strongValue>
                    <div className="label">
                      {this.props.agreementType == 'company' ? this.language['company_name'] : this.language['name']}
                    </div>
                    <div className="value">{address?.company_name || label}</div>
                  </DocField>
                );
              }
              if (type == 'phone_number') {
                let phoneNumber = (getPropByName(model, 'country_code') + getPropByName(model, 'phone_number') || getPropByName(model, 'telephonenr')) ?? '';
                if (address?.phone_number) {
                  phoneNumber = address?.phone_number;
                }
                return (
                  <DocField key={type} large strongValue>
                    <div className="label">{this.language[type]}</div>
                    <div className="value">{phoneNumber}</div>
                  </DocField>
                );
              }

              if (type == 'company_email') {
                return (
                  <DocField key={type} large strongValue>
                    <div className="label">
                      {this.props.agreementType == 'company' ? this.language['company_email'] : this.language['email']}
                    </div>
                    <div className="value">{address?.company_email || getPropByName(company, 'company_email')}</div>
                  </DocField>
                );
              }
              return (
                <DocField key={type} large strongValue>
                  <div className="label">{this.language[type]}</div>
                  <div className="value">
                    {type == 'postcodeAndPlace'
                      ? `${model?.['postcode'] ?? ''} ${model?.['city'] ?? ''}`
                      : type == 'addressLine1'
                      ? model?.[type]
                      : getPropByName(model, type)}
                  </div>
                </DocField>
              );
            })}
            <Line></Line>
          </VBox>
          <VBox id="vehicle-data">
            <HBox className="section-title">
              <strong>{this.language['vehicle_data']}</strong>
            </HBox>
            <HBox>
              <VBox style={{ width: '49.5%' }}>
                {['brand_name', 'model_name', 'vin', 'date_first_allowance'].map(type => (
                  <DocField key={type} large mediumValueWide strongValue>
                    <div className="label">{this.language[type]}</div>
                    <div className="value">{vehicle[type]}</div>
                  </DocField>
                ))}
                {['garantie'].map(type => (
                  <DocField key={type} large mediumValueWide strongValue>
                    <div className="label">{this.language[type]}</div>
                    <div className="value">
                      <HBox left style={{ fontSize: '14px' }}>
                        <Checkbox>{this.language['no']}</Checkbox>
                        <Checkbox>{this.language['yes']}</Checkbox>
                      </HBox>
                    </div>
                  </DocField>
                ))}
                {['NAP'].map(type => (
                  <DocField key={type} large mediumValueWide strongValue>
                    <div className="label">{this.language[type]}</div>
                    <div className="value">
                      <HBox left style={{ fontSize: '14px' }}>
                        <Checkbox>{this.language['logical']}</Checkbox>
                        <Checkbox>{this.language['illogical']}</Checkbox>
                      </HBox>
                    </div>
                  </DocField>
                ))}
              </VBox>
              <VBox style={{ width: '49.5%' }}>
                {['model_info', 'fuel_type', 'regplate', 'base_color', 'mileage'].map(type => {
                  let value = getPropByName(vehicle, type);
                  if (type == 'mileage') {
                    value = getPropByName(vehicle, type)
                      ? formatterDistance.format(getPropByName(vehicle, type))?.replace(',', '.')
                      : '';
                  }
                  return (
                    <DocField key={type} large mediumValueWide strongValue>
                      <div className="label">{this.language[type]}</div>
                      <div className="value">{value}</div>
                    </DocField>
                  );
                })}
                <DocField large withoutLabelField strongValue>
                  <div className="value">
                    <HBox spaceAround style={{ fontSize: '14px' }}>
                      <Checkbox checked={getPropByName(vehicle, 'vehicle_purpose') == VEHICLE_PURPOSE.Passenger}>
                        {this.language['passenger']}
                      </Checkbox>
                      <Checkbox checked={getPropByName(vehicle, 'vehicle_purpose') == VEHICLE_PURPOSE.Commercial}>
                        {this.language['commercial']}
                      </Checkbox>
                    </HBox>
                  </div>
                </DocField>
                <DocField large strongValue withoutLabelField>
                  <div className="value"></div>
                </DocField>
              </VBox>
            </HBox>
            <HBox className="section-title">
              <strong>{this.language['remaining_appointments']}</strong>
            </HBox>
            <DocField large withoutLabelField strongValue>
              <div className="value"></div>
            </DocField>
            <DocField large withoutLabelField strongValue>
              <div className="value"></div>
            </DocField>
            <DocField large withoutLabelField strongValue>
              <div className="value"></div>
            </DocField>
            <Line></Line>
          </VBox>
          {!env.clientId === AppClientId.INDEWAL && !env.clientId === AppClientId.IDWLEASE &&
            <VBox id="trade-invehicle-data" className="section">
              <HBox className="section-title">
                <strong>{this.language['details_of_trade_in']}</strong>
              </HBox>
              {this.state.tradeIn?.map(tradeInV => {
                return <HBox key={tradeInV?.id}>{this.renderTradeInFields(tradeInV)}</HBox>;
              })}
              {!this.state.tradeIn?.length && this.renderTradeInFields({})}
              <Line></Line>
            </VBox> 
          }
          <HBox>
            <VBox style={{ width: '49.5%' }}>
              <HBox className="section-title">
                <DocField labelOnly lightgrey>
                  <div className="label">{this.language['initial_block']}</div>
                </DocField>
              </HBox>
              <InitialsField>
                <div className="initial-field-description">
                  <strong>{this.language['vat_statement']}</strong>
                  <p>{this.language['buyier_declaration']}</p>
                </div>
                <div className="initials-input">
                  <span>{this.language['initials']}</span>
                </div>
              </InitialsField>
              <InitialsField>
                <div className="initial-field-description">
                  <strong>{this.language['garantie']}</strong>
                  <p>{this.language['garantie_n_v_t']}</p>
                </div>
                <div className="initials-input">
                  <span>{this.language['initials']}</span>
                </div>
              </InitialsField>
              <InitialsField>
                <div className="initial-field-description">
                  <strong>{this.language['mileage_history']}</strong>
                  
                   <p>{this.language['mileage_history_is_accepted_as_illogical']}</p>
                  <p>{this.language['mileage_history_is_accepted_as_illogical']}</p>
               
                </div>
                <div className="initials-input">
                  <span>{this.language['initials']}</span>
                </div>
              </InitialsField>
              <DocField large mediumValueWide>
                <div className="label">{this.language['date']}</div>
                <div className="value"></div>
              </DocField>

              <DocField height={'68px'} large mediumValueWide>
                <div className="label">{this.language['buyer_signature']}</div>
                <div className="value"></div>
              </DocField>
              <DocField large mediumValueWide>
                <div className="label">{this.language['date']}</div>
                <div className="value"></div>
              </DocField>

              <DocField height={'68px'} large mediumValueWide>
                <div className="label">{this.language['name_seller_signature']}</div>
                <div className="value"></div>
              </DocField>
            </VBox>
            <VBox style={{ width: '49.5%' }}>
              <HBox className="section-title">
                <DocField labelOnly lightgrey height={'40px'}>
                  <div className="label">
                    <HBox left vCenter>
                      <strong>price to deliver</strong>
                      <HBox style={{ fontSize: '10px', width: '200px' }}>
                        <Checkbox checked={getPropByName(vehicle, 'tax_type') == VEHICLE_TAX_TYPE.Marge}>
                          Tax type: {this.language['marge']}
                        </Checkbox>
                        <Checkbox checked={getPropByName(vehicle, 'tax_type') == VEHICLE_TAX_TYPE.BTW}>
                          Tax type: {this.language['btw']}
                        </Checkbox>
                      </HBox>
                      <span>{this.priceToDeliver && `€ ${fixPriceFormat(this.priceToDeliver)}`}test</span>
                    </HBox>
                  </div>
                </DocField>
              </HBox>
              {this.products?.length > 0
                ? this.products.map(prod => {
                    return (
                      <DocField key={prod.id} labelOnly height={'auto'} marginBottom={'6px'}>
                        <HBox className="label">
                          <VBox style={{ width: '70%' }}>
                            <Checkbox>{prod?.product?.name}</Checkbox>
                            <div>{prod?.product?.description}</div>
                          </VBox>
                          <VBox
                            center
                            style={{
                              backgroundColor: '#f4f7fe',
                              width: '30%',
                              minHeight: '90px',
                            }}
                          >
                            <span>{prod?.price && `€ ${fixPriceFormat(prod?.price)}`}</span>
                          </VBox>
                        </HBox>
                      </DocField>
                    );
                  })
                : [
                    'delivery_package',
                    'apk',
                    'maintenance',
                    'distribution',
                    'tyres',
                    'to_polish',
                    'restyling',
                    'towbar_7P_14P',
                    'autotrust_warranty',
                    'discount_due_to_no_warranty',
                  ].map(type => (
                    <DocField key={type} wideLabel height={'28px'} marginBottom={'6px'}>
                      <div className="label">
                        <Checkbox>{this.language[type]}</Checkbox>
                      </div>
                      <div className="value">
                        <HBox spaceAround style={{ fontSize: '14px' }}></HBox>
                      </div>
                    </DocField>
                  ))}
              <HBox className="section-title" style={{ width: '70%' }}>
                <strong>{this.language['obligated_to_charge']}: </strong>
              </HBox>

              <DocField wideLabel strongValue style={{ marginBottom: '36px' }}>
                <div className="label">{this.language['registration_payment']}</div>
                <div className="value"></div>
              </DocField>
              <DocField wideLabel strongValue>
                <div className="label">{this.language['subtotal_incl_bpm_vat']}</div>
                <div className="value">
                  <HBox spaceAround style={{ fontSize: '14px' }}>
                    <span>{`€ ${fixPriceFormat(this.subTotalAmount)}`}</span>
                  </HBox>
                </div>
              </DocField>
              <DocField wideLabel strongValue>
                <div className="label">{this.language['af_purchase_price']}</div>
                <div className="value">
                  <HBox spaceAround style={{ fontSize: '14px' }}>
                    {`€ ${fixPriceFormat(this.tradeInTotalPrice)}`}
                  </HBox>
                </div>
              </DocField>
              <DocField wideLabel height={'40px'} style={{ fontSize: '18px', marginBottom: '24px' }}>
                <div className="label">{this.language['total_paid_before_delivery']}</div>
                <div className="value">
                  <HBox spaceAround style={{ fontSize: '20px', fontWeight: '600' }}>{`€ ${fixPriceFormat(
                    this.totalAmounts,
                  )}`}</HBox>
                </div>
              </DocField>
              <DocField wideLabel strongValue>
                <div className="label">
                  <Checkbox>{this.language['deposit']}</Checkbox>
                </div>
                <div className="value">
                  <HBox spaceAround style={{ fontSize: '14px' }}></HBox>
                </div>
              </DocField>
            </VBox>
          </HBox>
          <SaleAgreementFooter />
        </Body>
      </Container>
    );
  }
}

CompanySaleAgreementComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(ownProps.outgoingInvoiceId),
    addressTypes: selectAddressTypes(),
    tradeInWork: selectWork(`${REQUEST_INVOICE_TRADE_IN_VEHICLES + ownProps.outgoingInvoiceId}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchTradeInVehicles(callback) {
      dispatch(getInvoiceTradeInVehicles(ownProps.outgoingInvoiceId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanySaleAgreement = compose(withConnect, withRouter)(CompanySaleAgreementComp);
